import { default as Standard } from './Standard'
import { default as One } from './One'
import { default as Buttony } from './Buttony'

export default {
  Standard,
  One,
  Buttony,
}
